import { isLeft } from "fp-ts/lib/Either"
import { PathReporter } from "io-ts/lib/PathReporter"

import { invalidApiDataError } from "../../../../errors/recognisedErrors"
import {
    AddressSuggestion,
    IAddressSuggestionResults,
    IAddressSuggestion,
} from "../../types/singleApplication/getAddressTypes"

export const getAddressMapper = {
    /**
     * Maps `Autocomplete` API response into UI data model
     */
    map: (response: unknown): IAddressSuggestionResults => {
        // Validate the API response
        const decoded = AddressSuggestion.decode(response)
        if (isLeft(decoded)) {
            const detail = `Could not validate data from getAddress endpoint: ${PathReporter.report(
                decoded
            ).join("\n")}`
            throw invalidApiDataError(detail)
        }

        const addressSpec: IAddressSuggestion = decoded.right

        return addressSpec.Results
    },
}
